import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthActions } from '@shared/store/auth/auth.actions';
import { AuthSelectors } from '@shared/store/auth/auth.selectors';
import { UnauthorizedLogicService } from 'app/view/auth/service/unauthorized-logic.service';
import { Observable } from 'rxjs';

@Component({
  selector: 'app-mid-auth-layout',
  templateUrl: './mid-auth-layout.component.html',
  styleUrls: [ './mid-auth-layout.component.scss' ],
  standalone: false
})
export class MidAuthLayoutComponent {
  public hasConfirmedReferral$: Observable<boolean> = this.store.select(AuthSelectors.hasConfirmedReferral);

  constructor(public router: Router, private store: Store,
              public unauthorizedLogicService: UnauthorizedLogicService) {
  }

  public logout(): void {
    this.store.dispatch(new AuthActions.Logout());
  }
}
